export default {"src":"https://cloudflare.edhrec.com/_next/static/media/managwu.70972dfa.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};